export const isCZRegulatory = state => state.market === 'CZ';

export const isSKRegulatory = state => state.market === 'SK';

export const isRegulatory = state => state.market === 'CZ' || state.market ===  'SK';

export const isWSRegulatory = state => state.market === 'WS';
